var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5681 3.15137H4.56812C3.46512 3.15137 2.56812 4.04837 2.56812 5.15137V19.1514C2.56812 20.2544 3.46512 21.1514 4.56812 21.1514H20.5681C21.6711 21.1514 22.5681 20.2544 22.5681 19.1514V5.15137C22.5681 4.04837 21.6711 3.15137 20.5681 3.15137ZM4.56812 19.1514V5.15137H20.5681L20.5701 19.1514H4.56812Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56812 7.15137H18.5681V9.15137H6.56812V7.15137ZM6.56812 11.1514H18.5681V13.1514H6.56812V11.1514ZM6.56812 15.1514H12.5681V17.1514H6.56812V15.1514Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDetail);
export default __webpack_public_path__ + "static/media/icons-detail.c01eeea9710153434a49404b05a55f3f.svg";
export { ForwardRef as ReactComponent };